import { render, staticRenderFns } from "./SingleLayerStyle.vue?vue&type=template&id=c47a66d0&scoped=true"
import script from "./SingleLayerStyle.vue?vue&type=script&lang=ts"
export * from "./SingleLayerStyle.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SingleLayerStyle.vue?vue&type=style&index=0&id=c47a66d0&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "c47a66d0",
  null
  ,true
)

export default component.exports